// extracted by mini-css-extract-plugin
export default {"card":"SimilarProduct_card__eeKR4","image":"SimilarProduct_image__T8-nf","name":"SimilarProduct_name__XNeuS","price":"SimilarProduct_price__hFnbs"};